import { Route } from '@angular/router';
import { AuthGuard } from '../../../shared/services';
import { StudentsForImpactListComponent } from './students-for-impact-list.component';

export const StudentsForImpactListRoutes: Route[] = [
  {
    path: 'list',
    component: StudentsForImpactListComponent,
    canActivate: [AuthGuard],
    resolve: {
    }
  }
];
